import { render } from "./RoleRow.vue?vue&type=template&id=32624b64"
import script from "./RoleRow.vue?vue&type=script&lang=js"
export * from "./RoleRow.vue?vue&type=script&lang=js"

import "./RoleRow.vue?vue&type=style&index=0&id=32624b64&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__